<template>
  <main class="my-leagues">
    <div class="desktop-bumper" />
    <!-- <section class="bg-white p-3 race-selector">
      <ims-race-selector />
    </section>-->
    <ims-item class="divider">My Leagues</ims-item>
    <!-- Start My Leagues -->
    <section class="bg-white league-list" v-if="$store.state.leagues.mine">
      <div class="item-wrapper" v-if="myLeagues.length == 0">
        <ims-item class="double pad ims-item-last">
          <h1>No Leagues Found</h1>
        </ims-item>
      </div>
      <div
        class="item-wrapper"
        v-for="(league, index) in myLeagues"
        :key="`avail-${index}`"
      >
        <ims-item
          detail="true"
          class="double pad"
          :to="`/leagues/${league.leagueId}`"
          :class="index == myLeagues.length - 1 ? 'ims-item-last' : ''"
        >
          <template v-slot:left>
            <div v-if="league.isPrivate">
              <ims-icon icon="lock" size="md" class="pl-1 text-faded" />
            </div>
            <!-- Official Badges -->
            <img
              class="brand-badge"
              v-if="league.isOfficial && league.isFirestone"
              :src="$Brand.get('firestone').badgeUrl"
              :alt="`badge`"
            />
            <!-- If it's official and not firestone -->
            <img
              class="brand-badge"
              v-else-if="league.isOfficial && !league.isFirestone"
              :src="$Brand.get('indycar').badgeUrl"
              :alt="`badge`"
            />
            <!-- End Official Badges -->
          </template>
          <template>
            <h1>
              {{ league.leagueName }}
              <ims-icon
                class="icon-admin ml-1"
                v-if="league.isAdmin"
                icon="brightness_auto"
                size="sm"
                color="green"
              />
            </h1>
            <!-- <div class="text-sm ims-row pt-1 league-status" v-if="league.isPrivate">
              <span class="ims-row mr-2 text-fade">
                <ims-icon icon="lock" size="xs" />Private
              </span>
            </div>-->
          </template>
          <template v-if="league.rank" v-slot:right>
            <ims-badge size="sm">{{ league.rank | ordinal }}</ims-badge>
          </template>
        </ims-item>
      </div>
    </section>
    <section v-else>
      <p>No leagues!</p>
    </section>
    <!-- End My Leagues -->
    <div class="league-actions">
      <ims-button
        type="solid"
        size="md"
        class="btn-block mx-auto mt-4 mb-2"
        @click="showLeagueManager"
        >Join a Public League</ims-button
      >
      <ims-button
        type="solid"
        size="md"
        class="btn-block mx-auto mt-2 mb-4"
        @click="showNewLeague"
        >Create a Private League</ims-button
      >
    </div>
  </main>
</template>

<script>
import tick from '../../modules/tick/tick';
export default {
  components: {},
  data() {
    return {};
  },
  computed: {
    myLeagues() {
      /**
       * To get My leages
       * we filter first
       */
      return this.$store.state.leagues.mine;
    }
  },
  methods: {
    init() {
      // this.$store.dispatch('races/load');
      this.$store.dispatch('leagues/mine/load');
      if (!this.$store.state.leagues.mine) {
        this.$store.dispatch('leagues/mine/load');
      }
    },
    showNewLeague() {
      this.$store.dispatch('interact/modals/newLeague');
    },
    showJoinLeague() {
      this.$store.dispatch('interact/modals/joinLeague');
    },
    showLeagueManager() {
      this.$store.dispatch('interact/modals/manageLeagues');
    }
  },
  watch: {},
  async mounted() {
    await tick(200);
    this.init();
  }
};
</script>

<style lang="scss">
@import '../../scss/utils/variables';
@import '../../scss/vendors/bootstrap-utils';

.league-list {
  .item-start {
    margin-right: -10px; // force icon and iconless labels to line up
  }
  .hidden {
    visibility: hidden;
  }
  .ims-badge {
    min-width: 60px !important;
    max-width: 80px !important;
  }
  .brand-badge {
    height: 40px;
  }
  .league-status {
    margin-left: -4px;
  }

  .icon-admin {
    vertical-align: middle;
  }
}
.my-leagues {
  .league-actions {
    max-width: 600px;
    margin: 10px auto;
    text-align: center;
    @include media-breakpoint-up(md) {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      button {
        margin: 20px !important;
      }
    }
  }
}
</style>
